
import React, { useState } from 'react';
import {BrowserRouter, Routes, Route, Link, NavLink} from "react-router-dom"  
import axios from 'axios';
import apiUrl from './Url';
import { useLanguage } from '../i18n/translations';

export default function NotifyAvailable({ onClose, notifyProductId, notifyCategoryId, country }){
    const { translate } = useLanguage();
    const [visible, setVisible] = useState(true);
    const [success, setSuccess] = useState(false);

    const closeModal = () => {
      setVisible(false);
      onClose();
    };


    const [email, setEmail] = useState('');
    const [error, setError] = useState('');
  
    const handleEmailChange = (event) => {
      setEmail(event.target.value);
      setError(''); // Clear the error when the user starts typing again
    };
  
    const handleSubmit = async (event) => {
      event.preventDefault();
    
      if (!email.trim()) {
        setError(translate('Email is required'));
      } else if (!isValidEmail(email)) {
        setError(translate('Invalid email format'));
      } else {
        try {
          const selectedCountry = country || localStorage.getItem('country') || 'BA';

          // Make your API call
          const response = await axios.post(`${apiUrl}/api/notify`, {
            email,
            country: selectedCountry,
            ...(notifyProductId ? { product_id: notifyProductId } : {}),
            ...(notifyCategoryId ? { category_id: notifyCategoryId } : {}),
          });
    
          console.log('API Response:', response.data);
          setSuccess(true);
        } catch (error) {
          console.error('Error submitting data:', error);
          setError(translate('An error occurred while sending your data. Please try again.'));
        }
      }
    };
  
    const isValidEmail = (value) => {
      // Basic email validation, you can use a more sophisticated validation library if needed
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return emailRegex.test(value);
    };
    
    return (
        <div className="fixed inset-0 z-[999] flex items-center justify-center p-4">
            
          {/* Dark backdrop */}
          <div
            className={`${
              visible ? 'opacity-75' : 'opacity-0'
            } fixed inset-0 bg-black transition-opacity duration-300`}
          ><button className='w-full h-screen' onClick={()=> closeModal()}></button></div>
    
          {/* Modal */}
          <div
            className={`${
              visible ? 'opacity-100 scale-100' : 'opacity-0 scale-95'
            } transition-all duration-300 fixed flex items-center justify-center w-full max-w-md mx-4`}
          >
            <div className="bg-white rounded-xl shadow-lg flex flex-col w-full">
                {/* Close button */}
                <div className='w-full justify-end flex p-4'>
                    <button 
                        onClick={()=> closeModal()}
                        className="text-brownSkin hover:text-brownSkin/70 transition-colors duration-300"
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
                            <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
                        </svg>
                    </button>
                </div>

                {/* Content */}
                <div className="px-8 pb-8">
                    <div className='w-full items-center justify-center flex flex-col mb-6'>
                        <h2 className='font-bold text-2xl text-brownSkin mb-3'>{translate('Notify me')}</h2>
                        <p className='text-center text-gray-700 text-base leading-relaxed'>
                            {translate('Enter your email address to be notified when the product becomes available again.')}
                        </p>
                    </div>
    
                    {success ? (
                        <div className='w-full text-center bg-green-100 text-green-800 rounded-lg p-4'>
                            {translate('You will be notified when the product becomes available.')}
                        </div>
                    ) : (
                        <>
                            <div className='w-full flex flex-col gap-4'>
                                <input
                                    type="email"
                                    id="email"
                                    name="email"
                                    value={email}
                                    onChange={handleEmailChange}
                                    placeholder={translate('Enter your email address')}
                                    required
                                    className='w-full border border-gray-300 rounded-lg px-4 py-3 text-base focus:outline-none focus:border-brownSkin transition-colors duration-300'
                                />
                                
                                {error && (
                                    <p className="text-red-600 text-sm text-center">{error}</p>
                                )}
                                
                                <button
                                    className="w-full bg-brownSkin text-white px-6 py-3 rounded-full text-base font-medium hover:bg-brownSkin/90 transition-all duration-300 shadow-lg hover:shadow-xl"
                                    onClick={handleSubmit}
                                >
                                    {translate('Send')}
                                </button>
                            </div>
                        </>
                    )}
                </div>
            </div>
          </div>
        </div>
      );
}